var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StackBuilder',{attrs:{"stacks":_vm.stacks,"projections":_vm.projections,"is-dirty":_vm.isDirty},on:{"create-stack":_vm.createStack,"stack-changed":_vm.onStackChange,"delete-stack":_vm.deleteStack,"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }